import { gql as apolloGql } from '@apollo/client';
import type { TypedDocumentNode } from '@graphql-typed-document-node/core';

import type { GetMeQuery } from '../../../generated/graphql/graphql.js';
import { gql } from '../../../generated/graphql/index.js';

// WHY: intersected in because web codegen reads a running API's schema, so GetMeQuery lags `hasMultiStateAccess`, `brands` and `readableBrands` until regenerated (a no-op after that).
type GetMeResult = {
  me:
    | (NonNullable<GetMeQuery['me']> & {
        hasMultiStateAccess: boolean;
        brands: Array<{ id: string; name: string }>;
        readableBrands: Array<{ id: string; name: string }>;
      })
    | null;
};

export const LOGIN_WITH_GOOGLE = gql(`
  mutation LoginWithGoogle($code: String!) {
    loginWithGoogle(code: $code) {
      id
      email
      firstName
      lastName
      permissions
    }
  }
`);

export const GET_ME: TypedDocumentNode<GetMeResult, Record<string, never>> = apolloGql`
  query GetMe {
    me {
      id
      email
      firstName
      lastName
      permissions
      hasActiveBrandMembership
      hasMultiStateAccess
      brands {
        id
        name
      }
      readableBrands: brands(includeInactive: true) {
        id
        name
      }
    }
  }
`;

export const LOGOUT = gql(`
  mutation Logout {
    logout
  }
`);
